export default __webpack_public_path__ + "static/media/screen1.729e002a.png";